import NonMemberPage, { CustomerAddInquiryPage, CustomerInformationPage, ProspectAddPage, ProspectInformationPage, TemporariesInfoPage, GuestProductionPage } from "@icoach/nonMember/";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";
// 顧客管理
const nonmemberRouter = [
	{
		description: "顧客總覽",
		frontKey: "C3X01",
	},
	{
		description: "顧客總覽",
		exact: true,
		path: NON_MEMBER_ROUTER.TABS.OVERVIEW_PAGE,
		href: NON_MEMBER_ROUTER.CUSTOMER.OVERVIEW,
		as: NonMemberPage,
		frontKey: "C3X02",
	},
	{
		description: "名單總覽",
		exact: true,
		path: NON_MEMBER_ROUTER.TABS.OVERVIEW_PAGE,
		href: NON_MEMBER_ROUTER.PROSPECT.OVERVIEW,
		as: NonMemberPage,
		frontKey: "C3X04",
	},
	{
		description: "暫存名單",
		exact: true,
		path: NON_MEMBER_ROUTER.TABS.OVERVIEW_PAGE,
		href: NON_MEMBER_ROUTER.TEMPORARIES.OVERVIEW,
		as: NonMemberPage,
		frontKey: "C3X06",
	},
	{
		description: "新增詢問",
		exact: true,
		path: NON_MEMBER_ROUTER.CUSTOMER.ADD_PAGE,
		href: NON_MEMBER_ROUTER.CUSTOMER.ADD_BASE,
		as: CustomerAddInquiryPage,
		frontKey: "C3X03",
	},
	{
		description: "新增名單",
		exact: true,
		path: NON_MEMBER_ROUTER.PROSPECT.ADD_PAGE,
		href: NON_MEMBER_ROUTER.PROSPECT.ADD_BASE,
		as: ProspectAddPage,
		frontKey: "C3X05",
	},
	{
		description: "顧客基本資料與聯絡記錄",
		exact: true,
		path: NON_MEMBER_ROUTER.CUSTOMER.INFO_PAGE,
		as: CustomerInformationPage,
		frontKey: "C3X09",
	},
	{
		description: "名單基本資料與聯絡記錄",
		exact: true,
		path: NON_MEMBER_ROUTER.PROSPECT.INFO_PAGE,
		as: ProspectInformationPage,
		frontKey: "C3X10",
	},
	{
		description: "暫存名單(顧客/名單)列表記錄",
		exact: true,
		path: NON_MEMBER_ROUTER.TEMPORARIES.INFO_PAGE,
		as: TemporariesInfoPage,
		frontKey: "C3X11",
	},
	{
		description: "主動顧客製造",
		exact: true,
		path: NON_MEMBER_ROUTER.ACTIONPLAN.OVERVIEW,
		href: NON_MEMBER_ROUTER.ACTIONPLAN.OVERVIEW,
		as: GuestProductionPage,
		frontKey: "C3X07",
	},
];

export default nonmemberRouter;
